<template>
  <section class="auth hero is-fullheight">
    <div class="hero-body is-centered">
      <div class="container is-centered">
        <RouterView />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Auth',
};
</script>

<style scoped>
.auth.hero.is-fullheight {
  height: 100vh;
  min-height: 100vh;
  overflow-y: auto;
}

.auth.hero .hero-body {
  padding: 0;
}
</style>

<style lang="scss">
.auth {
  img {
    height: auto;
    padding: 1rem 0;
  }

  .input:focus,
  .input.is-focused,
  .input:active,
  .input.is-active,
  .textarea:focus,
  .textarea.is-focused,
  .textarea:active,
  .textarea.is-active {
    border-color: $primary;
    box-shadow: 0 0 0 0.125em rgba(38, 47, 64, 0.25);
  }

  .is-centered {
    flex-direction: column;
  }

  .field {
    width: 100%;
  }

  .field .control .input {
    background: transparent;
  }

  .field .control .input::placeholder {
    opacity: .4;
  }

  .field .control .material-icons,
  .field .control .input:not(:focus):not(:placeholder-shown) {
    opacity: .7;
  }

  .field .control .input:not(.is-danger) .mdi {
    color: $primary;
  }

  .field .control .input:not(:focus):not(:placeholder-shown) .mdi {
    opacity: .4;
  }

  .field .control .input:focus + .icon .material-icons {
    opacity: 1;
  }

  .button.is-medium {
    margin-top: 1.5rem;
    margin-bottom: .5rem;
  }

  .button.is-text,
  .button.is-text:hover,
  .button.is-text:focus {
    background: none;
  }

  .submit-button {
    margin-top: 1rem;
  }

  @media screen and (max-width: 768px) {
    img {
      width: 200px;
    }

    h1.title.is-4 {
      color: whitesmoke!important;
    }

    .field .label,
    .field .control .input,
    .field .control .input::placeholder,
    .field .control .material-icons,
    .button.is-text.is-text {
      color: whitesmoke;
    }
  }

  @media screen and (min-width: 769px) {
    img {
      width: 300px;
    }

    .field .label,
    .field .control .input,
    .field .control .input::placeholder,
    .field .control .material-icons,
    .button.is-text {
      color: $primary;
    }
  }
}
</style>
